<template>
  <div>
    <div class="w-full mb-4">
      <label>До какого числа необходимо оплатить</label>
      <elsa-v-datepicker
        v-model="date"
        :danger="!!errors.date"
        :danger-text="errors.date"
        :clearable="false"
        :disabled="!date"
      />
    </div>

    <div class="w-full mb-4">
      <label>Индивидуальный текст</label>
      <elsa-v-select
        :options="templates"
        label="template_text"
        v-model="textTemplate"
        @input="errors.textTemplate = null"
        :danger="!!errors.textTemplate"
        :danger-text="errors.textTemplate"
      />
      <div v-if="textTemplate && textTemplate.id === -1" class="mt-2">
        <elsa-quill-editor
          v-model="text"
          :options="extraTextEditorConfig"
        />
      </div>
    </div>

    <div class="w-full flex justify-center">
      <vs-button type="border" class="mb-2" @click="onGenerate()">Начать генерацию</vs-button>
    </div>
  </div>
</template>

<script>
import ElsaQuillEditor from "@/components/ElsaQuillEditor";
import formatDate      from "@/client/helpers/formatDate";
import _pick           from "lodash/pick";
import notifyHttpError from "@/mixins/notifyHttpError";
import modalContext    from "@/mixins/modalContext";

export default {
  name:       "InvoiceGeneratePopup",
  props:      ['month', 'onSubmit', 'hasInvoiceLink'],
  mixins:     [notifyHttpError, modalContext],
  components: {
    ElsaQuillEditor,
  },
  data() {
    return {
      templates: [],

      date:         null,
      textTemplate: null,
      text:         null,

      errors: {
        date:         null,
        textTemplate: null,
      },

      extraTextEditorConfig: {
        modules: {
          toolbar:   ['bold', 'italic', 'underline'],
          clipboard: {
            matchers: [
              [Node.ELEMENT_NODE, ( node, delta ) => {
                delta.ops = delta.ops.map(op => ({
                  ...op,
                  attributes: _pick(op.attributes, ["bold", "italic", "underline"]),
                }));
                return delta;
              }],
            ],
          },
        },
      },
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    loadBeforeDay() {
      this.$http.get(`/house/${this.selectedHouseId}/pay/before/day`, { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.updatePaymentMonth(+data.parameters);
      }, () => this.updatePaymentMonth(10));
    },

    saveBeforeDay( day ) {
      this.$http.post(`/house/${this.selectedHouseId}/pay/before/day`, {
        buildings_id: this.selectedHouseId,
        day,
      }).then(( { data } ) => {
        console.log(data);
      });
    },

    loadTemplates() {
      this.$http.get(`kv_templates_texts`, { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.templates = [...data, { id: -1, template_text: 'Свой текст...' }];
      });
    },

    hasError() {
      for (let key in this.errors) {
        if (this.errors[key]) return true;
      }
      return false;
    },

    updatePaymentMonth( day ) {
      const month = new Date(this.month);
      month.setDate(day);
      month.setMonth(month.getMonth() + 1);
      this.date = month;
    },

    confirm() {
      const text = `На данный месяц уже показаны квитанции.
      Вы уверены что хотите ${this.hasInvoiceLink ? 'перегенерировать' : 'сгенерировать'} квитанцию за
      ${formatDate(this.month, 'LLLL yyyy')} для помещения`;

      this.$modal.open({
        size:           'sm',
        title:          'Подтверждение перегенерации квитанции',
        component:      () => import('@/components/calculated-program/account/ConfirmWordPopup'),
        componentProps: {
          // text:     `На данный месяц уже показаны квитанции.`,
          text,
          onAccept: () => this.onGenerate(true),
        },
      });
    },

    onGenerate( force ) {
      if (!this.date) this.errors.date = 'Обязательное поле';

      let text = '';
      if (this.textTemplate) {
        text = this.textTemplate.id === -1
          ? this.text.trim()
          : this.textTemplate.template_text;
      }

      if (this.hasError()) return;

      if (force) this.modalResolve();

      this.saveBeforeDay(this.date.getDate());

      this.onSubmit({
        date:  this.date,
        text,
        force: !!force,
      }).then(
        ( { data } ) => {
          if (!force) this.modalResolve();
          this.$vs.notify({
            color: 'warning',
            title: `Генерация квитанции запущена`,
            text:  `После завершения вам придет уведомление`,
          });
          // this.$vs.notify({
          //   color: 'success',
          //   title: `Квитанция ${data.anchor ? 'перегенерирована' : 'сгенерирована'}`,
          //   text:  `Квитанция успешно ${data.anchor ? 'перегенерирована' : 'сгенерирована'}`,
          // });
        },
        ( e ) => {
          const { response } = e;
          const { status, data } = response || {};
          if (status === 449) {
            return this.confirm();
          } else if (data && data.log) {
            const errorText = data.log.err_codes[data.log.errors[0].code];
            this.$vs.notify({ color: 'danger', title: 'Ошибка генерации', text: errorText });
          } else {
            this.notifyHttpError(e);
          }
        },
      );
    },
  },
  mounted() {
    this.loadTemplates();
    this.loadBeforeDay();
  },
};
</script>

<style lang="scss" module>
.errorText {
  position: relative;
  font-size: .65rem;
  overflow: hidden;
  transition: all .25s ease;
  color: rgba(var(--vs-danger), 1);
  padding: 2px 4px 4px;
}
</style>
